(ns superadmin.roles.queries
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn roles-query []
  #js {:queryKey #js ["v2-roles"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/roles {})))
       :staleTime (* 5 60 1000)})

(defn create-role-mutation []
  #js {:mutationKey #js ["create-role"]
       :mutationFn (fn [role-data]
                     (rf/dispatch [:loader/open])
                     (qhttp/post (qhttp/render :superadmin-api/roles {})
                                 {:body role-data}))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["v2-roles"]})
                       (rf/dispatch [:ocp/close])
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Role"
                                      :type :success
                                      :message "Successfully created role"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Role"
                                 :type :error
                                 :message "Failed to create role"
                                 :response (->clj response)}]))})

(defn update-role-mutation [{:keys [role-id]}]
  #js {:mutationKey #js ["update-role" role-id]
       :mutationFn (fn [role-data]
                     (rf/dispatch [:loader/open])
                     (qhttp/patch (qhttp/render :superadmin-api/update-role {:id role-id})
                                  {:body role-data}))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["v2-roles"]})
                       (rf/dispatch [:ocp/close])
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Role"
                                      :type :success
                                      :message "Successfully updated role"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Role"
                                 :type :error
                                 :message "Failed to update role"
                                 :response (->clj response)}]))})

(defn delete-role-mutation [{:keys [role-id]}]
  #js {:mutationKey #js ["delete-role" role-id]
       :mutationFn (fn []
                     (rf/dispatch [:loader/open])
                     (qhttp/delete (qhttp/render :superadmin-api/update-role {:id role-id})))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["v2-roles"]})
                       (rf/dispatch [:ocp/close])
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Role"
                                      :type :success
                                      :message "Successfully deleted role"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Role"
                                 :type :error
                                 :message "Failed to delete role"
                                 :response (->clj response)}]))})